(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Available Refills Info Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, UserSession,$state,webAnalytics,CAD,loggerService,loggerServiceHelper) {
    // console.log("Available Refills Info Controller Func: ", $scope);
    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED)+loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.PaymentConfirmation));
    log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));
    $scope.wcmContent = wcmContent;
    $scope.numRefills = UserSession && UserSession.accountData && UserSession.accountData.numRefills ? UserSession.accountData.numRefills  :0;
    $scope.dashboardLink=createChannelUrl('dashboard');
    var utagObj={
      "tsrc":cvsUtility.queryMap.source
    };
    $scope.returnToRegistration=function(refill){
      if(!refill){
      webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestPaymentSubmittedRegisterAndRefill");
      }
      /*$scope.switchTab("QR");*/
      CAD.setOPTabData({isSelected: false});
      CAD.setRFRTabData({isSelected: false});
      CAD.setQRTabData({isSelected: true});
      CAD.setTAPTabData({isSelected: false});
      /**/
      $state.go("RR");
    }
    /**
     * Vinoth 02/10/2017 - Feb 2017 Regression defect fix
     * Added logic to take member to payments module in mobile App
     * */
    $scope.returnToDashboard=function(){
      log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep("returnToDashboard"));
      log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
      if(UserSession.registered){
        webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "paymentConfirmationRefill");
        if(cvsUtility.setNativeCheck()){
          native.gotoPage('Refill');
        }else{
        window.top.location = createChannelUrl('dashboard');
        }
      }else{
        webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestPaymentSubmittedRefillNow");
        $scope.returnToRegistration(true);
      }
    }
  };

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/nextSteps/nextSteps.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "userSession","$state","webAnalytics","cvsAppData","loggerService","loggerServiceHelper"];
  angular.module('cvsApp').directive('nextSteps', directiveFunction);

})();
